// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag[data-v-22e9cfd6]:hover {\n  cursor: move;\n}", ""]);
// Exports
module.exports = exports;
